import React from "react";
import { useHistory } from "react-router-dom";

export default function P300Overview({ dataDashboard, onClickPendingOrder, onClickPendingRequest }) {

    const history = useHistory();
    const numeral = require('numeral');

    return (
        <div className="layout-dashboard">
            <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item1 cursor-mo"
                    // onClick={() => { history.push('/109') }}
                    >
                        <i className="overview-icon fas fa-file-contract"></i>
                        <div className="overview-numbers">{dataDashboard ? dataDashboard.totalContract : '-'}</div>
                        <div className="overview-subinfo">จำนวนสัญญา</div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item2"
                    //onClick={() => onClickPendingOrder()}
                    >
                        <img alt="babylon-layout" className="overview-icon" src="assets/layout/images/pipe2.png" style={{ width: 50, height: 61, opacity: 0.6 }} />
                        {/* <img class="MenuIcon" src="https://devperlab.com/data/parse/files/3013872d-ee69-44b5-8b55-ead0a2d35ed2/200ba5bc6a5eb46129867d4f0f54547f_pipe.svg"> */}
                        <div className="overview-numbers">{dataDashboard ? numeral(dataDashboard.totalPipeLength).format('0,0') : '-'}</div>
                        <div className="overview-subinfo">ความยาวท่อรวม (เมตร)</div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item3">
                        <img alt="babylon-layout"
                            className="overview-icon"
                            src="assets/layout/images/thai-baht2.png" style={{ width: 64, height: 61, opacity: 0.6 }}
                        />
                        <div className="overview-numbers">{dataDashboard ? numeral(dataDashboard.totalAmount).format('0,0.00') : '-'}</div>
                        <div className="overview-subinfo">มูลค่าโครงการรวม (ล้านบาท)</div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item7 cursor-mo"
                    //onClick={() => onClickPendingRequest()}
                    >
                        <i className="overview-icon fas fa-file-signature"></i>
                        <div className="overview-numbers">{dataDashboard ? dataDashboard.pendingAmount : '-'}</div>
                        <div className="overview-subinfo">จำนวนเงินยังไม่เบิก (ล้านบาท)</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
